import React, { useReducer, useContext, Dispatch } from 'react';
import { Action, State } from './SavedListing.types';
import reducer from './SavedListing.reducer';

export const SavedListingStateContext = React.createContext<State | undefined>(
    undefined
);

export const SavedListingDispatchContext = React.createContext<
    Dispatch<Action> | undefined
>(undefined);

const SavedListingProvider: React.FC = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, {
        listingId: undefined,
        isUser: undefined,
        isSaved: undefined,
        isSavedOptimistically: undefined,
        isUpdatingServer: undefined
    });

    return (
        <SavedListingStateContext.Provider value={state}>
            <SavedListingDispatchContext.Provider value={dispatch}>
                {children}
            </SavedListingDispatchContext.Provider>
        </SavedListingStateContext.Provider>
    );
};

const useSavedListingState = () => {
    const state = useContext(SavedListingStateContext);

    if (state === undefined) {
        throw new Error('Component must be descendent of SavedListingProvider');
    }

    return state;
};

const useSavedListingDispatch = () => {
    const dispatch = useContext(SavedListingDispatchContext);

    if (dispatch === undefined) {
        throw new Error('Component must be descendent of SavedListingProvider');
    }

    return dispatch;
};

export { SavedListingProvider, useSavedListingState, useSavedListingDispatch };
